export const RUNNING_AGENTS_POLL_MS = 10_000;

export const IDLE_AGENTS_POLL_MS = 60_000;
